import {useState, useEffect} from "react";

export default function useIsMobile() {
   const [isMobile, setMobile] = useState(false);
   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);

   return isMobile;
}
